// ===== Shared helpers for level data =====
// Collected from copies in the worlds' levels.ts/shared.ts, so they can share one version. May be imported from levels.ts.
import type { Static } from './types';

const DEG = Math.PI / 180;

/** Position on top of an (optionally sloped) shelf s: lx from the centre along the shelf, r = radius of the ball/part. extra is added. */
export function on<E extends object>(s: Pick<Static, 'x' | 'y' | 'h' | 'a'>, lx: number, r: number, extra?: E): { x: number; y: number; r: number } & E {
  const a = (s.a || 0) * DEG;
  const x = s.x + lx * Math.cos(a), y = s.y + lx * Math.sin(a) - (s.h / 2 + r + 1) / Math.cos(a);
  return Object.assign({ x: Math.round(x), y: Math.round(y), r }, extra || ({} as E));
}

/** y of the top side of a horizontal shelf */
export const top = (s: Pick<Static, 'y' | 'h'>) => s.y - s.h / 2;
